var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3131_38371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47311 8.40528C5.73188 8.90814 7.07392 9.15195 8.42086 9.13163C9.60617 9.14687 10.7866 8.95893 11.9131 8.58306C12.0943 8.52211 12.2658 8.45099 12.4323 8.37988C12.5988 8.30369 12.7654 8.22242 12.9221 8.12592L13.4119 7.86179C14.2396 7.29798 14.7294 6.57163 14.7294 5.77925V3.75258C14.7294 1.86306 11.9572 0.379883 8.42086 0.379883C4.88454 0.379883 2.11719 1.86306 2.11719 3.75258V5.75893C2.11719 6.84591 3.02821 7.79068 4.47311 8.40528Z",
    fill: "#8A90A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4992 8.66431L14.1711 9.49224C13.3923 11.4478 10.5564 12.7634 7.11312 12.7634C6.14822 12.7634 5.18332 12.6567 4.24291 12.4383L4.11557 12.4078C3.80699 12.3265 3.51312 12.2351 3.23883 12.1386C2.96455 12.0421 2.78332 11.9608 2.5874 11.8694V12.2453C2.5874 14.1348 5.35475 15.618 8.89108 15.618C10.3752 15.6484 11.8494 15.3437 13.2111 14.7291C14.4943 14.1043 15.1996 13.2053 15.1996 12.2453V10.2135C15.1752 9.61923 14.9205 9.06558 14.4992 8.66431Z",
    fill: "#8A90A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65613 10.7875C2.94511 10.9399 3.24878 11.072 3.55736 11.1786C3.80715 11.2701 4.04715 11.3513 4.34593 11.4225C5.24715 11.6409 6.17287 11.7526 7.10348 11.7475C10.1647 11.7475 12.648 10.6352 13.2553 9.10626L13.1867 9.14182C13.0496 9.21293 12.9223 9.27388 12.79 9.32467C12.6578 9.37547 12.4227 9.47706 12.2169 9.54817C10.9925 9.95959 9.71409 10.1628 8.42593 10.1475C7.01532 10.1678 5.6145 9.91896 4.29205 9.42118L4.11083 9.34499C2.22511 8.54753 1.13776 7.24214 1.13776 5.76404V5.2561C0.922254 5.58626 0.804703 5.97737 0.799805 6.37864V8.41039C0.799805 9.33991 1.47083 10.1729 2.57776 10.7825H2.65613V10.7875Z",
    fill: "#8A90A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3131_38371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.23af5d881fe9dc3e6b94c7d88174b959.svg";
export { ForwardRef as ReactComponent };